// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"Avatar_profileImage__28Gnx","clicked":"Avatar_clicked__2Qs5i"};